import { Pipe, PipeTransform } from '@angular/core';
import { SortField, SortOption } from '@shared/models/sort-option';
import * as _ from 'lodash';

export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc'
};

@Pipe({
  name: 'sortBy',
})
export class SortByPipe implements PipeTransform {
  transform(values: any, option: SortOption | null): any[] {
    if (!_.isArray(values) || !option?.field) {
      return values;
    }
    let sortFields: SortField[] = [];
    if (_.isString(option.field)) {
      sortFields.push({
        lookupField: option.field,
        direction: option.direction || SortDirection.Ascending
      });
    }
    else {
      sortFields = option.field;
    }
    return this.sortbyLookUp(values, sortFields);
  }

  //Sort products by Look up field and value
  private sortbyLookUp(values: any[], fields: SortField[]) {
    const sortingIteratees = fields.map(fieldItem => {
      if (fieldItem.lookupFieldType !== 'Array') {
        return fieldItem.lookupField;
      }
      return this.getOrderIterateeForArrayField(fieldItem);
    });
    return _.orderBy(values, sortingIteratees, fields.map(f => f.direction));
  }

  private getOrderIterateeForArrayField(options: SortField) {
    return (item: any) => this.getValuesByFieldPath(item, options.lookupField)?.includes(options.lookupValue);
  }

  private getValuesByFieldPath(item: any, lookupField: string) {
    return _.at(item, [lookupField])[0]
  }
}


